import { parseDeliveryTimeToScheduledTimezone } from 'app/pages/account/userAccount/schedule/utils';
import { Gap } from 'lib/components/styles/layout';
import { ParagraphSmallBold } from 'lib/components/styles/typography';
import React from 'react';
import { IoMdInformationCircle } from 'react-icons/io';
import styled, { useTheme } from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
import { getSecondaryColor } from 'lib/context/theme/utils';

const Container = styled(Gap)`
  box-sizing: border-box;
  padding: 12px;
  width: 100%;
  background: ${({ theme }) => theme.colors.neutral[10]};
  border: 1px solid ${({ theme }) => theme.colors.black[5]};
  border-radius: 6px;
`;

const Text = styled(ParagraphSmallBold)`
  color: ${({ theme }) => getSecondaryColor(theme)};
`;

type Props = {
  deliveryTime: string;
};
export const EditScheduleDeliveryTimeCard = ({ deliveryTime }: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const formattedDeliveryTime = parseDeliveryTimeToScheduledTimezone(
    deliveryTime || ''
  );

  return (
    <Container gap='12px' flexDirection='row' alignItems='flex-start'>
      <IoMdInformationCircle color={getSecondaryColor(theme, 60)} size={18} />
      <Text>
        {t('This email is scheduled to be sent on {{time}}', {
          time: formattedDeliveryTime,
        })}
      </Text>
    </Container>
  );
};
